import { render, staticRenderFns } from "./SignUpView.vue?vue&type=template&id=ae240cd6&scoped=true"
import script from "./SignUpView.vue?vue&type=script&lang=js"
export * from "./SignUpView.vue?vue&type=script&lang=js"
import style0 from "./SignUpView.vue?vue&type=style&index=0&id=ae240cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae240cd6",
  null
  
)

export default component.exports